// columnConfig.js

import ColumnType from "./ColumnType";

const columnConfig = Object.freeze({
  [ColumnType.ORDER_TYPE]: {
    label: "Typ",
  },
  [ColumnType.SUPPLIER_ORDER_NO]: {
    label: "Vårt ordernr", 
    sortField: "SupplierOrderNo",
    required: false,
  },
  [ColumnType.SUPPLIER_ORDER_REFERENCE]: {
    label: "KL Orderreferens", //Ska vara företagstext i framtiden!
    sortField: "SupplierOrderReference",
    required: true,
  },
  //[ColumnType.ORDER_ID]: {
  //  label: "Ert ordernr",
  //  sortField: "OrderId",
  //},
  [ColumnType.ORDER_REFERENCE]: {
    label: "Referens",
    sortField: "OrderReference",
  },
  [ColumnType.RECEIVER]: {
    label: "Kund / Mottagare",
    sortField: "DeliveryAddress1",
  },
  [ColumnType.ORDER_DATE]: {
    label: "Orderdatum",
    sortField: "OrderDate",
  },
  [ColumnType.SUMMARY]: {
    label: "Innehåll",
  },
  [ColumnType.DELIVERY_ADDRESS_2]: {
    label: "Leveransadress",
    sortField: "DeliveryAddress2",
  },
  [ColumnType.DELIVERY_DATE]: {
    label: "Önskat leveransdatum",
    sortField: "DeliveryDateWish",
  },
  [ColumnType.ORDER_STATUS]: {
    label: "Status",
    sortField: "OrderStatus",
  },
  [ColumnType.SOURCE]: {
    label: "Källa",
  },
  [ColumnType.ROW_COUNT]: {
    label: "Rader",
    align: "right",
  },
});

export default columnConfig;
